import { useEffect, useState } from "react";
import { Clock, Plus, X } from "lucide-react";
import CityPicker from "./CityPicker";

export default function WorldClock({ cities, onChange }) {
  const [now, setNow] = useState(new Date());
  const [adding, setAdding] = useState(false);

  useEffect(() => { const t = setInterval(() => setNow(new Date()), 1000 * 30); return () => clearInterval(t); }, []);

  const timeIn = (tz) => {
    try { return new Intl.DateTimeFormat("en-US", { hour: "numeric", minute: "2-digit", timeZone: tz }).format(now); }
    catch { return "—"; }
  };

  const add = (r) => {
    if (cities.some((c) => c.timezone === r.timezone && c.name === r.name)) { setAdding(false); return; }
    onChange([...cities, { name: r.name, country: r.country, timezone: r.timezone }]);
    setAdding(false);
  };
  const remove = (i) => onChange(cities.filter((_, idx) => idx !== i));

  return (
    <div className="border border-zinc-300 bg-white p-5" data-testid="world-clock">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-900 text-cyan-600 text-lg flex items-center gap-2"><Clock className="w-5 h-5" /> World Clock</h3>
        <button onClick={() => setAdding((a) => !a)} data-testid="worldclock-add" className="text-primary text-sm inline-flex items-center gap-1 hover:underline"><Plus className="w-4 h-4" /> Add city</button>
      </div>
      {adding && <div className="mb-3"><CityPicker autoFocus placeholder="Add a city to your clock…" onSelect={add} /></div>}
      {cities.length === 0 ? <p className="text-sm text-muted-foreground">Add cities to track times around the world.</p> : (
        <div className="space-y-2">
          {cities.map((c, i) => (
            <div key={i} className="flex items-center justify-between group" data-testid={`clock-${i}`}>
              <span className="text-sm">{c.name} <span className="text-muted-foreground">· {c.country}</span></span>
              <div className="flex items-center gap-2">
                <span className="font-mono font-600">{timeIn(c.timezone)}</span>
                <button onClick={() => remove(i)} className="opacity-0 group-hover:opacity-100 text-muted-foreground hover:text-destructive"><X className="w-3.5 h-3.5" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
